import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Box, Typography,Checkbox, FormControlLabel } from '@mui/material';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import FacilityTypeService from './../Services/FacilityType';
import StateService from '../Services/State'
import zipcodes from "zipcodes";
import { fetchDc } from '../Services/RoutingGuides';
import loaderGif from "./../Assests/loader.gif";

const StoreFormDialog = ({ open, handleClose, handleSave, initialData, isViewMode, initialData1 }) => {
  const initialFormData = {
    dc_id: '',
    facility_routing_status: '',
    facility_type_id: '',
    abbreviation: '',
    store_number: '',
    name: '',
    address: '',
    city: '',
    state_id: '', 
    zip: '',
    unit_limit: '',
    primary_contact_name: '',
    primary_contact_email: '',
    primary_contact_phone: '',
    primary_contact_fax: '',
    secondary_contact_name: '',
    secondary_contact_email: '',
    secondary_contact_phone: '',
    secondary_contact_fax: '',
    exceptions_allowed: false,
  };
  const requiredFields = ['dc_id', 'facility_routing_status','facility_type_id','abbreviation','store_number', 'name', 'address', 'state_id','unit_limit','city', 'zip'];
  // const [formData, setFormData] = useState(initialFormData);
  const [zipError, setZipError] = useState(""); // State for ZIP code error message
  const [allowException, setAllowException] = useState(initialData1?.exceptions_allowed || false);
  const [fieldErrors, setFieldErrors] = useState ({}); // State to track field errors

  // const [formData, setFormData] = useState(initialFormData);
  const [facilityTypes, setFacilityTypes] = useState([]);
  const [Dc, setDc] = useState([]);
  const [states, setStates] = useState ([]); // State to hold states data
  const [loading, setLoading] = useState(true); // Optional loading state
  const [error, setError] = useState(null); // Optional error state
  const [isSaving, setIsSaving] = useState(false);


  useEffect (
    () => {
      if (initialData) {
        console.log('initialData', initialData)
        setFormData (initialData);
      } else {
        console.log('else initialData', initialFormData)

        setFormData (initialFormData);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [initialData, open]
  );

  // useEffect (() => {
  //    StateService.fetchStates ();
  // }, []); // State to hold facility types
    // Fetch states when the component mounts
    useEffect(() => {
      const fetchStatesData = async () => {
        try {
         // Fetch states data from the service
          const response = await StateService.fetchStates();
          // Check if response.data is in expected format
          if (response && Array.isArray(response.data)) {
            console.log("Fetched States Data:", response.data);
            setStates(response.data); // Set the state data
          } else {
            console.error("Fetched data is not an array:", response);
            setError("Error: States data is not in expected format.");
          }
          setLoading(false);
        } catch (error) {
          console.error("Error fetching states:", error);
          setError("Failed to fetch states.");
          setLoading(false);
        }
      };
  
      fetchStatesData(); // Call the function to fetch states data
    }, []);
  const [formData, setFormData] = useState({
    facility_type_id: '',
  });


  useEffect(() => {
    const getFacilityTypes = async () => {
      try {
        const response = await FacilityTypeService.fetchFacilityTypes();
        console.log("Fetched Facility Types:", response);
        if (Array.isArray(response.data)) {
          setFacilityTypes(response.data);
        } else {
          console.error("Fetched data is not an array:", response.items);
        }
      } catch (error) {
        console.error("Error loading facility types:", error);
      }
    };

    getFacilityTypes();
  
  }, []); 

  useEffect(() => {
    const getDC = async () => {
      try {
        const response = await fetchDc();
        console.log("Fetched distribution center data:", response);
  
        // Check if the response itself is an array
        if (Array.isArray(response)) {
          setDc(response);
        } else {
          console.error("Fetched data is not an array:", response);
        }
      } catch (error) {
        console.error("Error loading distribution Center:", error);
      }
    };
  
    getDC();
  }, []);
  
  
  
  const handleCheckboxChange = (e) => {
    setAllowException(e.target.checked);
  };
  useEffect(() => {
    setFieldErrors({});
    if (initialData) {
      // If there is initial data, update formData with its values
      setFormData((prevData) => ({
        ...prevData,
        ...initialData,
        facility_routing_status: initialData?.facility_routing_status?.toUpperCase() || '',
      }));
    } else {
      // Reset to initialFormData when no initialData is available
      setFormData(initialFormData);
      console.log("initialFormData>>>>>>>", initialFormData);
    }
  }, [initialData, open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  
    if (name === "zip") {
      validateZip(value);
    }
  };
  const validateZip = (zip) => {
    const zipRegex = /^\d{5}$/; // Regex for 5-digit ZIP code
    if (!zipRegex.test(zip)) {
      setZipError("ZIP code must be 5 digits");
      return;
    }

    const location = zipcodes.lookup(zip);
    if (location) {
      setZipError(""); // Clear error if valid
      setFormData((prevData) => ({
        ...prevData,
        city: location.city,
        state_id: location.state, // Automatically set state if ZIP is valid
      }));
    } else {
      setZipError("Invalid ZIP code");
    }
  };
  
  const validateForm = () => {
    const errors = {};
  // Required fields validation
    if (!formData.dc_id) {
      errors.dc_id = 'DC Id is required';
  } else if (!Dc.some((item) => item.dc_id === formData.dc_id)) {
      errors.dc_id = 'DC ID must be a valid option';
  }
  if (!formData.facility_routing_status) {
    errors.facility_routing_status = 'Facility routing status is required';
  } else if (typeof formData.name !== 'string') {
    errors.facility_routing_status = 'Facility routing status must be a string';
  }
  // if (!formData.facility_type_id) {
  //   errors.facility_type_id = 'Facility type ID  is required';
  // } else if (!facilityTypes.some((item) => item.facility_type_id === formData.facility_type_id)) {
  //   errors.facility_type_id = 'Facility type ID  must be a valid option';
  // }
  if (!formData.name) {
    errors.name = 'store Name is required';
  } else if (typeof formData.name !== 'string') {
    errors.name = 'Store Name must be a string';
  }
    if (!formData.abbreviation) {
      errors.abbreviation = 'abbreviation is required';
    } else if (typeof formData.abbreviation !== 'string') {
      errors.abbreviation = 'abbreviation must be a string';
    }
    if (!formData.store_number) {
      errors.store_number = 'Store number is required';
    } else if (isNaN(Number(formData.store_number))) {
      errors.store_number = 'Store number must be a valid number';
    }
    

    if (!formData.address) {
      errors.address = 'Address is required';
    } else if (typeof formData.address !== 'string') {
      errors.address = 'Address must be a string';
    }
   if (!formData.city) {
      errors.city = 'City is required';
    } else if (typeof formData.city !== 'string') {
      errors.city = 'City must be a string';
    }
    if (!formData.state_id) {
      errors.state_id = 'State ID  is required';
    } else if (!states.some((item) => item.state_id === formData.state_id)) {
      errors.state_id = 'State ID  must be a valid option';
    }
    if (!formData.zip ) {
      errors.zip = 'Zip code is required';
    } else if (typeof formData.zip !== 'string' && (!/^\d{5}$/.test(formData.zip))) {
      errors.zip = 'ZIP code must be a 5-digit string';
    }
    if (!formData.unit_limit) {
      errors.unit_limit = 'Unit Limit is required';
    } else if (isNaN(parseFloat(formData.unit_limit))) {
      errors.unit_limit = 'Unit Limit must be a valid number';
    }
    // Optional fields validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(\d{10}|\d{3}-\d{3}-\d{4}|\d{2}-\d{2}-\d{2}-\d{2}-\d{2})$/;
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;
  
    if (formData.primary_contact_name && typeof formData.primary_contact_name !== "string") {
      errors.primary_contact_name = "Primary contact name must be a string";
    }
  
    if (formData.primary_contact_email && !emailRegex.test(formData.primary_contact_email)) {
      errors.primary_contact_email = "Primary contact email must be a valid email address";
    }
  
    if (formData.primary_contact_phone && !phoneRegex.test(formData.primary_contact_phone)) {
      errors.primary_contact_phone = "Primary contact phone must match the format XXXX-XXXX-XXXX";
    }
  
    if (formData.primary_contact_fax && !faxRegex.test(formData.primary_contact_fax)) {
      errors.primary_contact_fax = "Primary contact fax must match the format XXX-XXX-XXXX";
    }
  
    if (formData.secondary_contact_name && typeof formData.secondary_contact_name !== "string") {
      errors.secondary_contact_name = "Secondary contact name must be a string";
    }
  
    if (formData.secondary_contact_email && !emailRegex.test(formData.secondary_contact_email)) {
      errors.secondary_contact_email = "Secondary contact email must be a valid email address";
    }
  
    if (formData.secondary_contact_phone && !phoneRegex.test(formData.secondary_contact_phone)) {
      errors.secondary_contact_phone = "Secondary contact phone must match the format XXXX-XXXX-XXXX";
    }
  
    if (formData.secondary_contact_fax && !faxRegex.test(formData.secondary_contact_fax)) {
      errors.secondary_contact_fax = "Secondary contact fax must match the format XXX-XXX-XXXX";
    }
  
    setFieldErrors(errors);
  
    // Return true if no errors
    return Object.keys(errors).length === 0;
  };

  const handleSaveClick = async () => {
    if (validateForm()) {
      setIsSaving(true);
      try{
     await handleSave({
        ...formData,
       // dc_id: parseInt(formData.dc_id, 10) || null,
        facility_type_id: parseInt(formData.facility_type_id, 10) || null,
        store_number: parseInt(formData.store_number, 10) || null,
        state_id: formData.state_id,
        exceptions_allowed: allowException,
      });
      handleClose();
    }catch (error){
      console.error("error saving store:", error);
    }finally{
      setIsSaving(false);
    }
  }
  };

  

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle className='modal-header'>
        {initialData ? (isViewMode ? 'View Store' : 'Update Store') : 'Add New Store'}
      </DialogTitle>
      {isSaving && (
        <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={1}
      >
        <img src={loaderGif} alt="Loading..." width={50} height={50} />
      </Box>
      )}
      <DialogContent>
      <TextField
         select
          margin="dense"
          name="dc_id"
          label="DC Id"
          fullWidth
          variant="outlined"
          value={formData.dc_id}
          onChange={handleChange}
        >
            {Dc.map(option => (
            <MenuItem key={option.dc_id} value={option.dc_id}>
              {option.name}
            </MenuItem>
          ))}
          </TextField> 
          {fieldErrors.dc_id &&<div style={{color: 'red', fontSize: '0.875rem'}}>{fieldErrors.dc_id}</div>}
        
        <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel>Facility Routing Status</InputLabel>
          <Select
            name="facility_routing_status"
            value={formData.facility_routing_status || ''}
            onChange={handleChange}
              label="Facility Routing Status"
          >
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="INACTIVE">Inactive</MenuItem>
          </Select>
        </FormControl>
        {fieldErrors.facility_routing_status && (<div style={{ color: 'red', fontSize: '0.875rem' }}>{fieldErrors.facility_routing_status}</div>)}   
        <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel>Facility Type</InputLabel>
          <Select
            name="facility_type_id"
            value={formData.facility_type_id}
            onChange={handleChange}
            label="Facility Type"
          >
            {Array.isArray(facilityTypes) && facilityTypes.map((type) => (
            <MenuItem key={type.facility_type_id} value={type.facility_type_id}>
            {type.description}
           </MenuItem>
         ))}
          </Select>
        </FormControl>
        {fieldErrors.facility_type_id && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.facility_type_id}</div>)}
        <TextField
          margin="dense"
          name="name"
          label="Store Name"
          fullWidth
          variant="outlined"
          value={formData.name}
          onChange={handleChange}
        />
        {fieldErrors.name && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.name}</div>)}
        <TextField
          margin="dense"
          name="abbreviation"
          label="Abbreviation"
          fullWidth
          variant="outlined"
          value={formData.abbreviation}
          onChange={handleChange}
        />
        {fieldErrors.abbreviation && (<div style={{ color: 'red', fontSize: '0.875rem' }}>{fieldErrors.abbreviation}</div>)}
        <TextField
          margin="dense"
          name="store_number"
          label="Store Number"
          fullWidth
          variant="outlined"
          value={formData.store_number}
          onChange={handleChange}
          disabled={!!initialData}
         // disabled={!!formData.store_number}     
        />
        {fieldErrors.store_number && ( <div style={{ color: 'red', fontSize: '0.875rem' }}>{fieldErrors.store_number}</div>)}
        <TextField
          margin="dense"
          name="address"
          label="Address"
          fullWidth
          variant="outlined"
          value={formData.address}
          onChange={handleChange}
        />
        {fieldErrors.address && (<div style={{ color: 'red', fontSize: '0.875rem' }}>{fieldErrors.address}</div>)}
        <TextField
          margin="dense"
          name="city"
          label="City"
          fullWidth
          variant="outlined"
          value={formData.city}
          onChange={handleChange}
        />
        {fieldErrors.city && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.city}</div>)}
          <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel>State</InputLabel>
          <Select
            name="state_id"
            value={formData.state_id}
            onChange={handleChange}
            label="State"
          >
            {states.length > 0
              ? states.map (item => (
                  <MenuItem key={item.state_id} value={item.state_id}>
                    {item.state_name || 'Unknown State'}
                  </MenuItem>
                ))
              : <MenuItem value="">
                  No states available
                </MenuItem>}
          </Select>
        </FormControl>
        {fieldErrors.state_id && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.state_id}</div>)}
        <TextField
          margin="dense"
          name="zip"
          label="Zip Code"
          fullWidth
          variant="outlined"
          value={formData.zip}
          error={!!zipError} // Shows error styling
          // helperText={zipError} // Displays the error message
          onChange={handleChange}
          // error={!!errors.zip}
         // helperText={errors.zip}
        />
        {fieldErrors.zip && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.zip}</div>)}
        <TextField
          margin="dense"
          name="unit_limit"
          label="Unit Limit"
          fullWidth
          variant="outlined"
          value={formData.unit_limit}
          onChange={handleChange}
        />
        {fieldErrors.unit_limit && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.unit_limit}</div>)}
        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box flexGrow={1} mr={1}>
            <Typography variant="h6">Primary Contact Details</Typography>
            <TextField
              margin="dense"
              name="primary_contact_name"
              label="Name"
              fullWidth
              variant="outlined"
              value={formData.primary_contact_name}
              onChange={handleChange}
                />
        {fieldErrors.primary_contact_name && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.primary_contact_name}</div>)}
            <TextField
              margin="dense"
              name="primary_contact_email"
              label="Email"
              fullWidth
              variant="outlined"
              value={formData.primary_contact_email}
              onChange={handleChange}
                />
        {fieldErrors.primary_contact_email && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.primary_contact_email}</div>)}
            <TextField
              margin="dense"
              name="primary_contact_phone"
              label="Phone"
              fullWidth
              variant="outlined"
              value={formData.primary_contact_phone}
              onChange={handleChange}
                />
        {fieldErrors.primary_contact_phone && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.primary_contact_phone}</div>)}
            <TextField
              margin="dense"
              name="primary_contact_fax"
              label="Fax"
              fullWidth
              variant="outlined"
              value={formData.primary_contact_fax}
              onChange={handleChange}
                />
                  {fieldErrors.primary_contact_fax && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.primary_contact_fax}</div>)}

          </Box>
          <Box flexGrow={1} ml={1}>
            <Typography variant="h6">Secondary Contact Details</Typography>
            <TextField
              margin="dense"
              name="secondary_contact_name"
              label="Name"
              fullWidth
              variant="outlined"
              value={formData.secondary_contact_name}
              onChange={handleChange}
                />
        {fieldErrors.secondary_contact_name && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.secondary_contact_name}</div>)}
            <TextField
              margin="dense"
              name="secondary_contact_email"
              label="Email"
              fullWidth
              variant="outlined"
              value={formData.secondary_contact_email}
              onChange={handleChange}
                />
        {fieldErrors.secondary_contact_email && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.secondary_contact_email}</div>)}
            <TextField
              margin="dense"
              name="secondary_contact_phone"
              label="Phone"
              fullWidth
              variant="outlined"
              value={formData.secondary_contact_phone}
              onChange={handleChange}
                />
        {fieldErrors.secondary_contact_phone && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.secondary_contact_phone}</div>)}
            <TextField
              margin="dense"
              name="secondary_contact_fax"
              label="Fax"
              fullWidth
              variant="outlined"
              value={formData.secondary_contact_fax}
              onChange={handleChange}
                />
        {fieldErrors.secondary_contact_fax && (<div style={{ color: 'red', fontSize: '0.875rem' }}>  {fieldErrors.secondary_contact_fax}</div>)}
          </Box>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              name="exceptions_allowed"
              checked={allowException}
              onChange={handleCheckboxChange}
              color="primary"
                />
          }
          label="Allow Exception"
        />
      </DialogContent>
      <DialogActions>
      <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSaveClick} color="primary">
          {initialData ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoreFormDialog;
